import { getProfilePhotos } from "@/services/module_api";
import { ValueSignal } from "./state_signal";

export class AvatarCache {
  private cache = new Map<string, string>();
  readonly cacheUpdates = new ValueSignal<number>(0);

  async initialize(): Promise<void> {
    const entries = await getProfilePhotos();
    for (const entry of Object.values(entries)) {
      if (!entry?.userId || !entry.url) continue;
      this.cache.set(entry.userId, entry.url);
    }
    this.cacheUpdates.set(Date.now());
  }

  getPhotoUrl(userId: string): string | null {
    return this.cache.get(userId) || null;
  }

  updatePhoto(userId: string, url: string): void {
    this.cache.set(userId, url);
    this.cacheUpdates.set(Date.now());
  }

  removePhoto(userId: string): void {
    this.cache.delete(userId);
    this.cacheUpdates.set(Date.now());
  }

  size(): number {
    return this.cache.size;
  }

  hasPhoto(userId: string): boolean {
    return this.cache.has(userId);
  }

  getAllPhotos(): Record<string, string> {
    return Object.fromEntries(this.cache);
  }

  clear(): void {
    this.cache.clear();
    this.cacheUpdates.set(Date.now());
  }
}
